namespace com.enirva.net
{
	export class URLRequest
	{
		public url:string;
		
		constructor(url:string = null)
		{
			this.url = url;
		}
	}
}

